<template>
  <button-base-style
    :is-primary="isPrimary"
    :is-danger="isDanger"
    :is-disabled="disabled"
    :is-secondary="isSecondary"
    :is-thirdary="isThirdary"
  >
    <button
      :disabled="disabled"
      type="button"
      v-on="listeners"
      v-html="title"
    />
  </button-base-style>
</template>

<script>
import ButtonBaseStyle from '@/mikan/_shared/components/atoms/ButtonBaseStyle.vue';

export default {
  components: {
    ButtonBaseStyle,
  },
  props: {
    isPrimary: {
      type: Boolean,
      default: false,
    },
    isDanger: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    isThirdary: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: e => this.$emit('input', e.target.value),
      };
    },
  },
};
</script>
